import { useState } from 'react'
import { DriverStatusType, IGetDriversFilters } from 'apps/fleet-planner/types/driver'
import { SortFieldType, SortOrderType } from '../types/hooks'

export interface IDriverFilters extends IGetDriversFilters {
  status?: DriverStatusType
}

export interface IUseDriverParamsState {
  sortField?: SortFieldType
  sortOrder?: SortOrderType
  filters?: IDriverFilters
}

/**
 * Hook used to manage getDrivers params
 */
export const useDriverParams = (
  defaults: IUseDriverParamsState = {
    sortField: 'name',
    sortOrder: 'asc',
  }
) => {
  const [params, setParams] = useState<IUseDriverParamsState>(defaults)

  return {
    params,
    setParams,
  }
}
